import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useDropzone } from "react-dropzone";
import "../dropzone/dropzone.css";
import Dropdown from "../../Icon/Dropdown";
import { FormHelperText, Typography } from "@mui/material";
import { FontFamily } from "../theme/fontFamily";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import { ThemeColor } from "../theme/color";
import Delete from "../../Icon/Delete";
import { UploadFileService } from "../../Redux/service/FileService";

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  //   marginTop: 16
};

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid black",
  //   marginTop: 10,
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};

const img = {
  display: "block",
  width: "auto",
  height: "100%",
};

const Mylogodropzone = forwardRef((props, ref) => {
  // const [files, setFiles] = useState([]);
  // const { getRootProps, getInputProps } = useDropzone({
  //   accept: {
  //     "image/*": [],
  //   },
  //   multiple: true,
  //   onDrop: async (acceptedFiles) => {
  //     try {
  //       const formData = new FormData();
  //       var docsFile = [];

  //       for (let i = 0; i < acceptedFiles.length; i++) {
  //         formData.append("file", acceptedFiles[i]);

  //         let response = await UploadFileService(formData);
  //         // //("photoresp", response);
  //         if (response.status == 200) {
  //           docsFile.push(response.data.result);
  //         }

  //         //
  //       }
  //       //(docsFile);
  //       // return docsFile;
  //     } catch (err) {
  //       //("uploadPhotoPost : err ", err);
  //     }
  //     // const updatedFiles = [
  //     //   acceptedFiles.map((file) =>
  //     //     Object.assign(file, {
  //     //       preview: URL.createObjectURL(file),
  //     //     })
  //     //   ),
  //     // ];
  //     setFiles(
  //       acceptedFiles.map((file) =>
  //         Object.assign(file, {
  //           preview: URL.createObjectURL(file),
  //         })
  //       )
  //     );
  //     console.log(
  //       acceptedFiles.map((file) =>
  //         Object.assign(file, {
  //           preview: URL.createObjectURL(file),
  //         })
  //       )
  //     );
  //     //   setFiles([...files, ...acceptedFiles]);
  //     props.handleMyLogodropzoneFile(docsFile?.[0]?.url);
  //   },
  // });

  // const handleRemove = (index) => {
  //   const newFiles = [...files];
  //   newFiles.splice(index, 1);
  //   setFiles(newFiles);
  //   props.handleMyLogodropzoneFile(newFiles);
  // };

  // const thumbs = files.map((file, index) => (
  //   <div style={thumb} key={file.name}>
  //     <div style={thumbInner}>
  //       <img
  //         src={file.preview}
  //         style={img}
  //         // Revoke data uri after image is loaded
  //         onLoad={() => {
  //           URL.revokeObjectURL(file.preview);
  //         }}
  //       />
  //       <button onClick={() => handleRemove(index)}>Remove</button>
  //     </div>
  //   </div>
  // ));

  // useEffect(() => {
  //   //(files, "nonnoon");
  //   // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
  //   return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  // }, []);

  const [files, setFiles] = useState([]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/*": [],
    },
    multiple: false,
    onDrop: async (acceptedFiles) => {
      // setFiles(...files,
      //   ...acceptedFiles.map((file) =>
      //     Object.assign(file, {
      //       preview: URL.createObjectURL(file),
      //     })
      //   )
      // );
      // console.log(acceptedFiles, "dropzone clg");
      var docsFile = [];

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const formData = new FormData();
          formData.append("file", file);
          //  console.log(formData, "form data");

          const response = await UploadFileService(formData);
          if (response.status === 200) {
            console.log(response.data.result?.url);
            docsFile.push({
              ...response.data.result,
              preview: URL.createObjectURL(file),
            });
          }
        });

        // Wait for all uploads to complete
        await Promise.all(uploadPromises);
      } catch (err) {
        //("uploadPhotoPost : err ", err);
      }
      // const updatedFiles = [
      //   ...files,
      //   ...acceptedFiles.map((file) =>
      //     Object.assign(file, {
      //       preview: URL.createObjectURL(file),
      //     })
      //   ),
      // ];
      console.log(docsFile);
      //(docsFile, "docs file");
      setFiles(docsFile);

      // props?.handleMydropzoneFile(docsFile);

      //   setFiles([...files, ...acceptedFiles]);
    },
  });

  const downloadFile = async (file) => {
    // console.log(file, "url of file in my drop zone");
    // const proxyUrl = "https://cors-anywhere.herokuapp.com/";
    // const response = await fetch(`${proxyUrl}${file}`);
    // const blob = await response.blob();
    // const blobUrl = URL.createObjectURL(blob);
    // const link = document.createElement("a");
    // link.href = blobUrl;
    // link.setAttribute("download", "Group.png");
    // document.body.appendChild(link);
    // link.click();
    // link.remove();
    // URL.revokeObjectURL(blobUrl);

    window.open(file, "_blank", "noopener noreferrer");
  };

  useEffect(() => {
    // This will be called whenever `files` is updated
    if (files.length > 0) {
      props?.handleMydropzoneFile(files);
    }
  }, [files]);
  const someFunction = (values) => {
    setFiles(values);
    props.handleMydropzoneFile(values);
  };

  const someEditFunction = () => {
    setFiles(props.initialValue);
    // props.handleMydropzoneFile(props.initialValue);
  };

  useImperativeHandle(ref, () => ({
    someFunction,
    someEditFunction,
  }));

  const handleRemove = (index) => {
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
    props.handleMydropzoneFile(newFiles);
  };

  const previewFile = (file) => {
    window.open(file.url, "_blank");
  };

  useEffect(() => {
    //(props.initialValue, "nonnoon");
    setFiles(props.initialValue);
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    // return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, []);

  return (
    <section className="my-logodropzone-container">
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        <div className="my-dropzone-content" style={{ position: "relative" }}>
          <div className="my-logodropzone-logo">
            <img
              src={
                files?.length > 0
                  ? files?.[0]?.preview
                  : "/assest/dropzonelogo.png"
              }
              className="w-100 h-100"
              style={{ borderRadius: "50%" }}
              alt="logo"
            ></img>
          </div>

          <Typography
            fontFamily={FontFamily.Lato}
            fontSize={fontSize.h4.medium}
            fontWeight={fontWeight.W500}
            color={ThemeColor.PURPLE}
          >
            {
              props?.text || "Upload University Logo"
            }
            
          </Typography>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        {files?.length > 0 && (
          <button
            onClick={() => handleRemove(0)}
            // className="w-100"
            style={{
              background: ThemeColor.RED,
              borderColor: ThemeColor.RED,
              borderRadius: "50%",
              boxShadow: "none",
              // position: "absolute",
              // top: "5px",
              // right:"10px"
            }}
          >
            <Delete />
          </button>
        )}
      </div>

      {/* <aside style={thumbsContainer}>{thumbs}</aside> */}
      {/* <div className="h-100 w-100">
        <ul>
          {files?.map((file, index) => (
            <li key={index} className="d-flex align-items-center">
              {file.name} - {file.size} bytes
              <div className="px-2">
                <button
                  onClick={() => handleRemove(index)}
                  className=""
                  style={{
                    background: ThemeColor.RED,
                    borderColor: ThemeColor.RED,
                    borderRadius: "50%",
                    boxShadow: "none",
                  }}
                >
                  <Delete />
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div> */}
      <FormHelperText component="div">{props.helperText}</FormHelperText>
    </section>
  );
});

export default Mylogodropzone;
